import React, {Suspense, useState} from "react";
import itemsListStyles from "../ProductSeries/ItemsList.module.scss";
import itemCardStyles from "../ProductSeries/ItemCard.module.scss";
import {useTranslation} from "react-i18next";
import imageStyles from "../ProductSeries/Image.module.scss";
import {PublicationDetailedType} from "./helper/cataloguesHelper";

const publitasViewUrl = "https://view.publitas.com";

const CatalogueSwiper: React.FC<{
  catalogues: PublicationDetailedType[];
}> = ({catalogues}) => (
  <div className={itemsListStyles.slider}>
    {catalogues.map((catalogue, index) => (
      <Suspense key={index} fallback={null}>
        <CatalogueThumbs catalogue={catalogue} />
      </Suspense>
    ))}
  </div>
);

const CatalogueThumbs: React.FC<{catalogue: PublicationDetailedType}> = ({catalogue}) => {
  const {t} = useTranslation();
  const [className, setClassName] = useState<string>(imageStyles.image);

  const src1x = publitasViewUrl + catalogue.spreads[0].pages[0] + "-at600.jpg";
  const src2x = publitasViewUrl + catalogue.spreads[0].pages[0] + "-at1200.jpg";
  const src = src1x;
  const srcSet = `${src1x} 1x, ${src2x} 2x`;
  const {origin, pathname, search} = window.location;
  const usp = new URLSearchParams(search);

  // Anchor link param is needed in the PublitasPortal.run() method, to set src of the iframe
  usp.set("publitas-medium", catalogue.config.slug);

  const anchorLink = origin + pathname + "?" + usp.toString();

  const onLoad = () => setClassName([imageStyles.image, imageStyles.loaded].join(" "));

  return (
    <a
      className={`${itemCardStyles.itemWrapper} ${itemCardStyles.swipeable} ${itemCardStyles.catalogueThumbs}`}
      title={t("{{title}} aufrufen", {title: catalogue.config.publicationTitle})}
      href={anchorLink}
    >
      <img
        alt={catalogue.config.publicationTitle}
        title={t("{{title}} aufrufen", {title: catalogue.config.publicationTitle})}
        src={src}
        srcSet={srcSet}
        onLoad={onLoad}
        className={className}
      />
    </a>
  );
};

export default CatalogueSwiper;
